<template>
  <BaseViewComponent
    name="footer"
    :is-preview="isPreview"
  >
    <div
      v-if="pageFields.footerNotice"
      class="footer-container q-py-md text-p text-center"
    >
      {{ pageFields.footerNotice }}
    </div>
    <q-separator
      size="1"
    />
    <div class="flex justify-between q-pa-lg">
      <div>
        <img
          :src="getCompressImage(footerImage)"
          width="140"
        >
      </div>
      <div class="flex">
        <q-item
          v-for="(item, index) in pageFields.footerItems"
          :key="index"
          clickable
          :href="item.url || item.publicUrl"
          :target="item.type === 'external' ? '_blank' : '_self'"
          class="font-color"
        >
          <q-item-section>
            {{ item.title }}
          </q-item-section>
        </q-item>
      </div>
    </div>
  </BaseViewComponent>
</template>

<script setup>
import BaseViewComponent from 'components/book-landing/render/BaseViewComponent.vue';
import { useBookPageStore } from 'stores/bookPage';
import useBookPageEdit from 'src/composables/useBookPageEdit';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import getCompressImage from 'src/helpers/getCompressImage';

const props = defineProps({
  isPreview: {
    type: Boolean,
    default: false,
  },
  data: {
    type: Object,
    default: null,
  },
});

const { footerImage } = useBookPageEdit(props.data);

const bookPageStore = useBookPageStore();
const { pageData } = storeToRefs(bookPageStore);

const pageFields = computed(() => props.data || pageData.value);
</script>

<style lang="scss" scoped>
.footer-container {
  max-width: 800px;
  margin: 0 auto;
}

:deep(.q-item) {
  .q-focus-helper {
    display: none;
  }

  &:hover {
    text-decoration: underline;
    color: var(--page-primary-color);
  }
}
</style>
